"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Shield, Scale, Briefcase } from "lucide-react";
export default function FeatureCards() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: Shield,
    title: "Berbasis Fakta",
    description: "Argumentasi hukum berdasarkan pembuktian faktual yang kuat"
  }, {
    icon: Scale,
    title: "Integritas Moral",
    description: "Kejujuran dan tanggung jawab dalam setiap langkah hukum"
  }, {
    icon: Briefcase,
    title: "Profesional",
    description: "Tim berpengalaman dengan manajemen perkara modern"
  }];
  return <section id="feature-cards" ref={sectionRef} className="dark bg-background text-foreground py-16 px-4 sm:px-8">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className={`
                  bg-secondary border border-border rounded-xl p-8 
                  transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
                  hover:border-primary hover:shadow-medium hover:-translate-y-2
                  ${isVisible ? "animate-reveal" : "opacity-0"}
                `} style={{
            animationDelay: `${i * 100}ms`
          }}>
                <CardContent className="flex flex-col items-start gap-4 p-0">
                  <div className="
                      text-primary transition-transform duration-[var(--duration-medium)] 
                      ease-[var(--ease-out-back)] group-hover:scale-110
                      hover:scale-110 hover:-translate-y-1
                    ">
                    <Icon size={56} strokeWidth={1.5} />
                  </div>
                  <h3 className="text-foreground font-semibold text-xl leading-tight">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-base leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}